import React, { Component } from 'react';
import AuthService from './AuthService';
import { find } from 'lodash'

//added 06-25-18
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Contactus from './Contactus';
// end added 06-25-18

class Simulationsdropdown extends Component {

  state = {
    segments: [],
    selected: undefined,
    loading: true,
    simulationObj: {}
  }

  constructor(props) {
    super(props);

    this.getToken = this.getToken.bind(this);
    this.fetchSegments = this.fetchSegments.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  fetchSegments(building, reselect) {
    const bearerToken = this.getToken();

    this.setState({ loading: true }, () => {
      fetch(`https://simulateapiprod.azurewebsites.net/api/simulations/${building.clientName}/${building.siteName}`, {
      //fetch(`https://astcloudrestservice.azurewebsites.net/api/simulations/${building.clientName}/${building.siteName}`, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': `Bearer ${bearerToken}`
        },
      }).then(response => {
        if (!response.ok && response.status === 404) {
          this.setState({ segments: [], selected: undefined, loading: false })
          this.props.noSegmentsFound(true);
          return Promise.reject(response);
        }
        this.props.noSegmentsFound(false);
        return response.json();
      }).then(simulation => {
        console.log(simulation);

        if (simulation) {
          let selectIndex = 0;
          if (reselect) {
            selectIndex = this.state.selected;
          }
          this.setState({ segments: simulation.segments, selected: selectIndex, loading: false, simulationObj: simulation })
          this.props.onSelect(simulation.segments[selectIndex], reselect, this.state.simulationObj)
          this.props.noSegmentsFound(false);
        } else {
          this.setState({ segments: [], loading: false })
          this.props.noSegmentsFound(true);
        }
      }).catch(() => {
        this.props.noSegmentsFound(true);
      });
    })
  }

  onChange(e) {
    this.setState({ selected: e.target.value })

    const id = e.target.value;
    const segment = this.state.segments[id];
    this.props.onSelect(segment, false, this.state.simulationObj);
  }

  componentWillMount() {
    if (this.props.building) {
      this.fetchSegments(this.props.building)
    }
  }

  componentWillReceiveProps(props) {
    if (this.props.building !== props.building) {
      this.fetchSegments(props.building);
    }// } else if (this.props.simulation !== props.simulation) {
    //   this.fetchSegments(props.building, true)
    // }
  }

  getToken() {
    return localStorage.getItem('id_token');
  }

  render() {
    const { showHelpTab } = this.props;
    if (this.state.loading) {
      return <p>Loading...</p>
    }
    else {
      if (this.state.segments.length === 0) {
        return <p>No simulations found, please email <a className="contact_lnk" href="mailto:support@cenergistic.com">support@cenergistic.com</a> for assistance.</p>;
        /* return <p>No simulations found, please email, <Link to="/contactus">support@cenergistics.com</Link> for assistance.</p>;
        <Router>
          <div>
            <Route path="/contactus" component={Contactus}/>
          </div>
        </Router> */

      }
    }
    const segmentName = item => item.segmentName.replace(item.simName,'').replace('~',' ');
    return (
      <div>
        <select className="custom-select" id="simulations" value={this.state.selected} onChange={this.onChange}>
          {this.state.segments.map((item, index) => (
            <option key={index} value={index}>{segmentName(item)}</option>
          ))
          }
        </select>
      </div>
    );
  }
}

export default Simulationsdropdown;



// WEBPACK FOOTER //
// ./src/components/Simulationsdropdown.js